import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m18.25 22.08-2.75-3 1.16-1.16 1.59 1.59 3.59-3.59L23 17.33l-4.75 4.75" }, null, -1),
    _createElementVNode("path", { d: "M14.415 21H1L12 2l6.948 12a4.963 4.963 0 0 0-2.063.467L12 6 4.5 19H14a4.965 4.965 0 0 0 .415 2z" }, null, -1),
    _createElementVNode("path", { d: "M14 14h-1.5l1.5-3h-4v4h1v3z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "CheckManual"}) } }